export class STATUS_ENUM {
  public static ACCEPTED = "A";
  public static REACTIVED = "E";
  public static TO_PLANIFY = "F";
  public static PLANIFIED = "L";
  public static SUSPENDED = "N";
  public static CREATED = "P";
  public static TRANSFERED = "S";
  public static TERMINATED = "T";
  public static IN_PROGRESS = "V";
  public static REFUSED = "X";
}

export enum ServiceRequestStatusEnum {
  ACCEPTED = "ACCEPTED",
  CANCELED = "CANCELED",
  DELETED = "DELETED",
  REACTIVATED = "REACTIVATED",
  OPENED = "OPENED",
  TRANSMITTED = "TRANSMITTED",
  CLOSED = "CLOSED",
  URGENT = "URGENT",
  REFUSED = "REFUSED",
}
